/**
 * Mock workspace data, each workspace owns a unique brand-gradient identity.
 * The hex pairs are workspace identity, not theme palette, so they live here as
 * data (not in `tokens.css`). Real (authenticated) workspaces get their `plan`
 * from `useEntitlements()` (see `use-active-workspace.tsx`); this mock array
 * only backs anonymous dev sessions, where there's no account to resolve
 * entitlements for.
 */

export type Workspace = {
  id: string;
  /** URL slug, drives `/<slug>/...` paths. */
  slug: string;
  name: string;
  isDemo?: boolean;
  isReadOnly?: boolean;
  mark: string;
  /** Inline CSS gradient string for the workspace mark background. */
  markBackground: string;
  /** Raw plan key (e.g. "pulse") for real workspaces, a mock label ("Free"
   * /"Team"/"Pro") for anonymous ones. Resolve to a display label via
   * `resolvePlanLabel` (`@/shared/entitlements/entitlements.constants`)
   * before rendering. */
  plan: string;
  memberCount: number;
  /** Does this workspace run requisitions and staffing plans? Comes off
   * `/auth/me`, so every member can read it, including the hiring manager who
   * cannot read HR settings. Optional here because the anonymous mock
   * workspaces below carry no such setting; absent means the shore's default,
   * which is on. Read it through `showsHiringGovernance`, never directly. */
  hiringGovernanceEnabled?: boolean;
  /// `YYYY-MM-DD` when the workspace is recording another calendar day.
  operatingDate?: string | null;
};

export const WORKSPACES: Workspace[] = [
  {
    id: "pulsewise",
    slug: "pulsewise",
    name: "Pulsewise HQ",
    mark: "P",
    markBackground: "var(--pw-pulse)",
    plan: "Pro",
    memberCount: 28,
  },
  {
    id: "acme",
    slug: "acme",
    name: "Acme Studio",
    mark: "A",
    markBackground: "linear-gradient(135deg,#06B6D4,#14B8A6)",
    plan: "Team",
    memberCount: 12,
  },
  {
    id: "north",
    slug: "north",
    name: "North & Vine",
    mark: "N",
    markBackground: "linear-gradient(135deg,#F59E0B,#F43F5E)",
    plan: "Team",
    memberCount: 6,
  },
  {
    id: "maya",
    slug: "maya",
    name: "Maya Personal",
    mark: "M",
    markBackground: "linear-gradient(135deg,#6366F1,#7C3AED)",
    plan: "Free",
    memberCount: 1,
  },
];
